// extracted by mini-css-extract-plugin
module.exports = {"appSitesSummary":"BasePartnerAppSitesSummary-appSitesSummary-JAWiFP","addAppSiteButton":"BasePartnerAppSitesSummary-addAppSiteButton-2EOBK4"};